export const BLACK = 'rgb(0,0,0)'; //1
export const WHITE = 'rgb(255,255,255)'; //1
export const BLUE600 = 'rgb(0,30,80)'; // 1
export const BLUE200 = 'rgb(0,176,240)'; // 1
export const MINT100 = '#00E6E6'; //2
export const GREEN300 = '#00C971'; // 2
export const RED100 = '#FF335C'; // 1
export const ORANGE100 = '#FF6D36'; // 3
export const YELLOW100 = '#FFD100'; // 2
export const BLUE900 = '#0040C5'; // 3
export const BLUE100 = '#4CC7F4'; // 3
export const PURPLE100 = '#5B0BA4'; // 3
export const GREY400 = 'rgb(106,118,125)'; // 2
export const GREY300 = 'rgb(150,163,168)'; // 2
export const GREY200 = 'rgb(194,202,207)'; // 3
export const GREY100 = 'rgb(223,228,232)'; // 2

export const BLACK_85 = 'rgba(0,0,0,0.85)'; //1
export const BLACK_80 = 'rgba(0,0,0,0.80)'; //1
export const BLACK_65 = 'rgba(0,0,0,0.65)'; //1
export const BLACK_45 = 'rgba(0,0,0,0.45)'; //1
export const BLACK_25 = 'rgba(0,0,0,0.25)'; //1
export const BLACK_10 = 'rgba(0,0,0,0.10)'; //1

export const WHITE_85 = 'rgba(255,255,255,0.85)'; //1
export const WHITE_80 = 'rgba(255,255,255,0.80)'; //1
export const WHITE_65 = 'rgba(255,255,255,0.65)'; //1
export const WHITE_45 = 'rgba(255,255,255,0.45)'; //1
export const WHITE_25 = 'rgba(255,255,255,0.25)'; //1
export const WHITE_05 = 'rgba(255,255,255,0.05)'; //1

export const GREY300_65 = 'rgba(150,163,168, 0.65)'; // 2
export const GREY200_65 = 'rgba(194,202,207, 0.65)'; // 3

export const BLUE600_65 = 'rgba(0,30,80,0.65)'; // 1
export const BLUE600_05 = 'rgba(0,30,80,0.05)'; // 1
export const BLUE200_65 = 'rgba(0,176,240, 0.65)'; // 1

export const WhiteDefault = '#FFFFFF';
export const BlackDefault = '#000000';

export const BlueLight01 = '#00B0F0';
export const BlueDark = '#001E50';

export const LightGrey = '#DFE4E8';
export const InputBackground = '#DFE4E8';
export const MidGrey = '#96A3A8';
export const TextGrey = '#6A777E';
export const LightGreyDisable = '#E0E4E8';

export const InputWarning = '#EF3A5E';
export const Purple = '#5B08A4';
export const Green = '#48AD3E';
export const Yellow = '#FDD10C';

export const colorBlueText = '#00B0F0';

export const Blue600 = '#001E50';
export const blue200 = '#00B0F0';
export const mint100 = '#00E6E6';
export const green300 = '#00C971';
export const red100 = '#FF335C';
export const orange100 = '#FF6D36';
export const yellow100 = '#FFD100';
export const blue900 = '#0040C5';
export const blue100 = '#4CC7F4';
export const purple900 = '#5B0BA4';
export const linkText = 'rgb(0,0,239)';
export const grey400 = '#6A767D';
export const grey300_65 = 'rgba(150,163,168,0.65)';
export const grey300 = '#96A3AB';
export const grey200 = '#C2CACF';
export const grey100 = '#DFE4EB';

export const WHITE_10 = 'rgba(255,255,255,0.25)';
